export default {
    appParams: {
        value: "Значення",
        cancel: "Скасувати",
        enterParamName: "Введіть назву параметру",
    },
    dBase: {
        createBase: "Створити базу",
        bindExistingBase: "Прив'язати існуючу базу",
        server: "Сервер",
        serverNotSelected: "Сервер не обраний",
        base: "База",
        baseNotSelected: "База не обрана",
        name: "Назва",
        shortName: "Коротка назва",
        alias: "Аліас",
        comment: "Коментар",
        baseType: "Тип бази",
        baseTypeNotSelected: "Тип бази не обраний",
        cancel: "Скасувати",
        enterBaseName: "Введіть назву бази даних",
        enterServer: "Введіть сервер",
        enterBaseShortName: "Введіть коротку назву бази даних",
        enterBaseType: "Введіть тип бази",
        enterBaseServer: "Введіть сервер бази",
        createError: "Помилка при створенні, зверніться до розробника",
    },
    form: {
        formName: "Назва форми",
        insert: "Додати",
        edit: "Редагувати",
        server: "сервер",
        app: "програму",
        dataBase: "базу даних",
        appParam: "параметр програми",
        user: "користувача",
        task: "завдання",
        role: "роль"
    },
    param: {
        paramType: "Тип параметра",
        value: "Значення",
        paramTypeNotSelected: "Тип параметра не обраний",
        cancel: "Скасувати",
        enterParamType: "Введіть тип параметра",
        enterParamValue: "Введіть значення параметра",
    },
    role: {
        value: "Значення",
        specialUserChecked: "Особливий користувач",
        cancel: "Скасувати",
        enterRoleName: "Введіть назву ролі",
    },
    section: {
        name: "Назва",
        alias: "Аліас",
        path: "Шлях",
        server: "Сервер",
        serverNotSelected: "Сервер не обраний",
        appType: "Тип програми",
        appTypeNotSelected: "Тип програми не обраний",
        appBelongsWeb: "Програма належить Web",
        cancel: "Скасувати",
        enterAppName: "Введіть назву програми",
        enterAppPath: "Введіть шлях програми",
        enterAppServer: "Введіть сервер програми",
        enterAppType: "Введіть тип програми",
    },
    server: {
        name: "Назва",
        serverTypeNotSelected: "Тип сервера не обраний",
        serverType: "Тип сервера",
        pathHttp: "Шлях http",
        host: "Хост",
        path: "Шлях",
        cancel: "Скасувати",
        enterServerName: "Введіть назву сервера",
        enterServerType: "Введіть тип сервера",
        enterServerPathUrl: "Введіть шлях http сервера",
        enterServerHost: "Введіть хост сервера",
        enterServerPath: "Введіть шлях сервера",
    },
    task: {
        taskName: "Назва завдання",
        path: "Шлях",
        taskType: "Тип завдання",
        opportunityPickInPackage: "Можливість збирати в пакет",
        comment: "Коментар",
        cancel: "Скасувати",
        enterTaskName: "Введіть назву завдання",
        enterTaskPath: "Введіть шлях завдання",
        enterTaskType: "Введіть тип завдання",
    },
    user: {
        login: "Логін",
        password: "Пароль",
        fullName: "ПІБ",
        expirationDate: "Дата закінчення дії",
        role: "Роль",
        blockUser: "Заблокувати користувача",
        cancel: "Скасувати",
        enterUserLogin: "Введіть логін користувача",
        enterUserFullName: "Введіть повне ім'я користувача",
        enterEndDate: "Введіть дату закінчення дії",
        enterPassword: "Введіть пароль",
        enterRole: "Введіть роль",
    },
    errors: {
        notAllRequiredFieldsSelected: "Не всі обов'язкові поля обрані",
        nameHasSpace: "Не повинне містити пробілів",
    }
}